import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, NgModule, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { HomeThemeReactorComponent } from '~app-client/home/_internal';
import {
	AppUrlOpenReactorComponent,
	FontSizeReactorComponent,
	KeyboardReactorComponent,
	SafeAreaReactorComponent,
	ScreenReactorComponent,
	SettingsReactorComponent,
	UserReactorComponent,
} from '~app-client/root/_internal/components';
import { COMMON_CLIENT_CONFIG } from '~ng-common-lib/core/tokens/client-config';

@Component({
	standalone: false,
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'general' }, multi: true },
		{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'node-type' }, multi: true },
	],
})
export class AppPageComponent implements OnInit {
	private readonly clientConfig = inject(COMMON_CLIENT_CONFIG);
	private readonly title = inject(Title);
	private readonly meta = inject(Meta);

	public ngOnInit(): void {
		const config = this.clientConfig;
		this.title.setTitle(config.branding.appTitle);
		this.meta.updateTag({ name: 'application-name', content: config.branding.appTitle });

		const googleClientId = config.features.authentication.googleSignInClientId;
		if (config.features.authentication.allowGoogleLogin && googleClientId) {
			this.meta.updateTag({
				name: 'google-signin-client_id',
				content: googleClientId,
			});
			return;
		}

		this.meta.removeTag("name='google-signin-client_id'");
	}
}

@NgModule({
	declarations: [AppPageComponent],
	imports: [
		CommonModule,
		TranslocoModule,
		RouterModule,

		AppUrlOpenReactorComponent,
		HomeThemeReactorComponent,
		SettingsReactorComponent,
		SafeAreaReactorComponent,
		UserReactorComponent,
		ScreenReactorComponent,
		KeyboardReactorComponent,
		FontSizeReactorComponent,
	],
	exports: [AppPageComponent],
})
export class AppPageModule {}
